"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var chevron_left_24_svg_1 = __importDefault(require("@/assets/svg/chevron-left-24.svg"));
var chevrondouble_left_24_svg_1 = __importDefault(require("@/assets/svg/chevrondouble-left-24.svg"));
var chevron_right_24_svg_1 = __importDefault(require("@/assets/svg/chevron-right-24.svg"));
var chevrondouble_right_24_svg_1 = __importDefault(require("@/assets/svg/chevrondouble-right-24.svg"));
var Pagination_component_1 = require("../Pagination.component");
var Styled = __importStar(require("./PageButtonList.styled"));
var utils_1 = require("@/utils");
var PageButtonList = function (_a) {
    var currentPage = _a.currentPage, startPage = _a.startPage, endPage = _a.endPage, totalPages = _a.totalPages, handleChangePage = _a.handleChangePage;
    var prevPage = startPage <= Pagination_component_1.FIRST_PAGE ? 0 : startPage - 1;
    var nextPage = endPage >= totalPages ? 0 : endPage + 1;
    var pages = (0, utils_1.rangeArray)(endPage - startPage + 1).map(function (_, diff) { return startPage + diff; });
    if (currentPage === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.ArrowButton, __assign({ role: "link", "aria-label": "First page", disabled: currentPage === Pagination_component_1.FIRST_PAGE, onClick: function () { return handleChangePage(Pagination_component_1.FIRST_PAGE); } }, { children: (0, jsx_runtime_1.jsx)(chevrondouble_left_24_svg_1.default, {}, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Styled.ArrowButton, __assign({ role: "link", "aria-label": "Previous page", disabled: startPage === Pagination_component_1.FIRST_PAGE, onClick: function () { return handleChangePage(prevPage); } }, { children: (0, jsx_runtime_1.jsx)(chevron_left_24_svg_1.default, {}, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Styled.OrderedList, { children: pages.map(function (page) {
                    var isActive = page === currentPage;
                    return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(Styled.PageButton, __assign({ role: "link", "aria-label": "Page ".concat(page), "aria-current": isActive && 'page', disabled: isActive, onClick: function () { return handleChangePage(page); } }, { children: page }), void 0) }, "page".concat(page)));
                }) }, void 0), (0, jsx_runtime_1.jsx)(Styled.ArrowButton, __assign({ role: "link", "aria-label": "Next page", disabled: endPage === totalPages, onClick: function () { return handleChangePage(nextPage); } }, { children: (0, jsx_runtime_1.jsx)(chevron_right_24_svg_1.default, {}, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Styled.ArrowButton, __assign({ role: "link", "aria-label": "Last page", disabled: currentPage === totalPages, onClick: function () { return handleChangePage(totalPages); } }, { children: (0, jsx_runtime_1.jsx)(chevrondouble_right_24_svg_1.default, {}, void 0) }), void 0)] }, void 0));
};
exports.default = PageButtonList;
